var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 100,
    viewBox: "0 0 73 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99323 65.2999L12.8474 1.92077C12.9181 1.45064 13.1353 1.0148 13.4682 0.67535C13.801 0.335901 14.2325 0.110156 14.7012 0.0302766C15.1698 -0.0496029 15.6518 0.0204575 16.0783 0.230476C16.5048 0.440495 16.8541 0.77976 17.0766 1.19994L27.6724 21.0791L2.99323 65.2999ZM72.9682 80.6833L63.5932 22.3499C63.5289 21.9377 63.3513 21.5514 63.0802 21.2343C62.809 20.9172 62.455 20.6818 62.0578 20.5542C61.6605 20.4267 61.2356 20.4122 60.8306 20.5122C60.4255 20.6123 60.0563 20.823 59.7641 21.1208L0.601562 80.6874L33.3349 99.1333C34.3451 99.7009 35.4844 99.999 36.6432 99.999C37.802 99.999 38.9413 99.7009 39.9516 99.1333L72.9682 80.6833ZM46.3682 29.7791L38.7849 15.2708C38.5936 14.9059 38.3061 14.6004 37.9535 14.3872C37.601 14.174 37.1969 14.0613 36.7849 14.0613C36.3729 14.0613 35.9688 14.174 35.6163 14.3872C35.2637 14.6004 34.9762 14.9059 34.7849 15.2708L1.49323 74.9333L46.3682 29.7791Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.d7bb4a0acb14efc95f3dfd444819d43c.svg";
export { ForwardRef as ReactComponent };